import { Container, Row, Col, Card, Image } from "react-bootstrap";
import sampleTrend1 from '../../../../../components/Assests/Icons/sampleTrend1.png';
import sampleTrend2 from '../../../../../components/Assests/Icons/sampleTrend2.png';
import sampleTrend3 from '../../../../../components/Assests/Icons/sampleTrend3.png';
import sampleTrend4 from '../../../../../components/Assests/Icons/sampleTrend4.png';
import './SampleTrend.css';
import '../../../../../styles/typography.css';

const METRICS = [
  {
    icon: sampleTrend1,
    label: "TAT (Days)",
    color: "#003087",
    key: "totalTurnAroundTime",
  },
  {
    icon: sampleTrend2,
    label: "% Metric",
    color: "#003087",
    key: "percentageMetric",
  },
  {
    icon: sampleTrend3,
    label: "Sample Received",
    color: "#003087",
    key: "totalSamplesReceived",
  },
  {
    icon: sampleTrend4,
    label: "Sample Tested",
    color: "#003087",
    key: "samplesTested",
  },
];

const SampleTrend = ({ data = {} }) => (
  <Card className="shadow-sm border-0 rounded sample-trend-container">
    <Card.Body>
      <Card.Title className="mb-3 fs-5 text-start default-font-styles">
        Sample Trend
      </Card.Title>

      <Container fluid className="p-0">
        <Row xs={2} md={2} className="g-3">
          {METRICS.map(({ icon, key, label, color }) => (
            <Col key={label}>
              <Card className="border-1 rounded sample-trend-card h-100">
                <Card.Body className="p-2 d-flex flex-column justify-content-between">
                  <div className="d-flex justify-content-between align-items-start">
                    <span
                      className="fw-bold fs-5 default-font-styles"
                      style={{ color }}
                    >
                      {key === "totalTurnAroundTime"
                        ? data[key] !== undefined && data[key] !== null && !isNaN(data[key])
                          ? Number(data[key]).toFixed(2)
                          : "N/A"
                        : data[key] !== undefined
                          ? data[key]
                          : "N/A"}
                    </span>
                    <Image
                      src={icon}
                      alt={label}
                      width={20}
                      height={20}
                      className="ms-1"
                    />
                  </div>
                  <small className="mt-1 default-font-styles fs-13">{label}</small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Card.Body>
  </Card>
);

export default SampleTrend;
